/**
 * @desc 修改供应商信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierInfoUpdateRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
